import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import frontpageLight from '../images/bet_image.png';
import frontpageDark from '../images/Frontpagev1.png';

const Hero = ({ isDark }) => {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "The Super Tip - Home",
            "description": "The Super Tip - Sport Tipping platform with live odds, sports betting tips, and expert predictions. Start tipping with The Super Tip today.",
            "url": "https://thesupertip.com",
            "mainEntity": {
              "@type": "Organization",
              "name": "The Super Tip",
              "description": "Leading sports tipping platform offering betting odds, predictions, and sports analysis for football, basketball, tennis, and more.",
              "url": "https://thesupertip.com",
              "logo": "https://thesupertip.com/logo192.png"
            }
          })
        }}
      />
      <motion.section
      className="min-h-screen flex items-center justify-center relative overflow-hidden backdrop-blur-lg transition-colors duration-500"
      style={{ backgroundImage: isDark ? `url(${frontpageDark})` : `url(${frontpageLight})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
    >
      {/* Subtle texture background */}
      {isDark && (
        <>
          <div className="absolute inset-0 opacity-5">
            <div className="w-full h-full bg-gradient-to-r from-primary to-beige transform -skew-y-1"></div>
          </div>
          <div className="absolute inset-0 opacity-20 bg-[radial-gradient(circle_at_center,transparent_0,rgba(0,0,0,0.1)_100%)]"></div>
          <div className="absolute inset-0 bg-black bg-opacity-40"></div>
        </>
      )}

      <div className="z-10 text-center px-4 sm:px-6 max-w-4xl">

        <motion.h1
          className={`title-shine font-display font-semibold ${isDark ? 'text-gold' : 'text-black'} text-4xl md:text-6xl lg:text-7xl uppercase tracking-wide mb-4 title-shadow`}
          initial={{ y: -50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.8 }}
        >
          The Super Tip
        </motion.h1>
        <motion.p
          className="font-body font-normal leading-relaxed text-base md:text-lg lg:text-xl mb-8 max-w-2xl mx-auto"
          style={{ color: isDark ? '#ffffff' : '#000000' }}
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.6, duration: 0.8 }}
        >
          Experience the thrill of sports tipping with cutting-edge odds and exciting offers.
        </motion.p>
        <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 0.9, duration: 0.8 }}
        >
          <Link to="/sports">
            <motion.button
              className="bg-gold text-black px-8 py-4 rounded-lg font-sans font-semibold text-lg shadow-lg hover:shadow-xl hover:bg-goldlight dark:bg-goldburn dark:hover:bg-goldlight hover:scale-105 transition-all duration-300"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Best Tips
            </motion.button>
          </Link>
        </motion.div>
      </div>
    </motion.section>
    </>
  );
};

export default Hero;
